import { RouteConfig } from "vue-router"

export const locationGroupRoutes: RouteConfig[] = [
    {
        path: "location-groups/:locationGroupId",
        component: () => import("@/views/location-groups/LocationGroup.vue"),
        meta: { type: "location-group", maintainsContext: false },
        children: [
            {
                path: "",
                component: () => import("@/views/location-groups/LocationGroupHeaderView.vue"),
                meta: { title: "Flexibility", maintainsContext: false },
                children: [
                    {
                        path: "",
                        redirect: "flexibility",
                        name: "LocationGroupDefault",
                    },
                    {
                        path: "flexibility",
                        name: "LocationFlexibilityView",
                        component: () =>
                            import("@/views/location-groups/LocationGroupFlexibilityView.vue"),
                        meta: {
                            title: "Flexibility",
                            type: "location-group-flexibility",
                            maintainsContext: false,
                        },
                    },
                ],
            },
            {
                path: "locations/:locationId",
                component: () => import("@/views/location/Location.vue"),
                meta: { title: "Location", type: "location", maintainsContext: false },
                children: [
                    {
                        path: "",
                        name: "GroupLocationAnimation",
                        component: () => import("@/views/location/LocationOverview.vue"),
                        meta: { type: "location", maintainsContext: false },
                    },
                    {
                        path: "reports",
                        component: () => import("@/layouts/Wrapper.vue"),
                        meta: { title: "Reports", maintainsContext: false },
                        children: [
                            {
                                path: "",
                                name: "GroupLocationReports",
                                component: () => import("@/views/Report.vue"),
                                meta: { title: "Reports", maintainsContext: false },
                            },
                        ],
                    },
                    {
                        path: "manage",
                        component: () => import("@/layouts/Wrapper.vue"),
                        meta: {
                            title: "Manage Location",
                            type: "manage-location",
                            maintainsContext: false,
                        },
                        children: [
                            {
                                path: "",
                                name: "GroupManageLocation",
                                component: () => import("@/views/settings/ManageLocation.vue"),
                                meta: {
                                    title: "Manage Location",
                                    type: "manage-location",
                                    maintainsContext: false,
                                },
                            },
                            {
                                path: "settings",
                                name: "GroupLocationSettings",
                                component: () => import("@/views/location/LocationSettings.vue"),
                                meta: {
                                    title: "Settings",
                                    type: "location-settings",
                                    maintainsContext: false,
                                },
                            },
                            {
                                path: "users",
                                name: "GroupLocationUsers",
                                component: () => import("@/views/settings/Users.vue"),
                                meta: {
                                    title: "Users",
                                    type: "location-users",
                                    maintainsContext: false,
                                },
                            },
                            {
                                path: "structure",
                                name: "GroupLocationStructure",
                                component: () => import("@/views/settings/LocationEdit.vue"),
                                meta: {
                                    title: "Structure",
                                    type: "location-structure",
                                    maintainsContext: false,
                                },
                            },
                            {
                                path: "oem-devices",
                                component: () => import("@/layouts/Wrapper.vue"),
                                meta: {
                                    title: "Devices",
                                    useDynamicTitle: true,
                                    maintainsContext: false,
                                },
                                children: [
                                    {
                                        path: "",
                                        name: "GroupLocationOEMDevices",
                                        component: () => import("@/views/settings/OEMDevices.vue"),
                                        meta: {
                                            title: "Devices",
                                            useDynamicTitle: true,
                                            maintainsContext: false,
                                            type: "location-controllers",
                                        },
                                    },
                                    {
                                        path: ":oemDeviceId",
                                        name: "GroupLocationOEMDevice",
                                        component: () =>
                                            import("@/views/settings/oem-device/OEMDevice.vue"),
                                        meta: { title: "Device", maintainsContext: false },
                                    },
                                    {
                                        path: ":oemDeviceId/devices/:deviceId",
                                        name: "GroupOEMDeviceDevice",
                                        component: () => import("@/views/settings/Device.vue"),
                                        meta: { title: "Device Settings", maintainsContext: false },
                                    },
                                ],
                            },
                            {
                                path: "pricing",
                                component: () => import("@/layouts/Wrapper.vue"),
                                meta: {
                                    title: "Utility rate plans",
                                    useTitle: true,
                                    maintainsContext: false,
                                },
                                children: [
                                    {
                                        path: "",
                                        name: "GroupLocationGroupPricing",
                                        component: () => import("@/views/UtilityRatePlan.vue"),
                                        meta: {
                                            title: "Utility Rate Plan",
                                            type: "location-utility-plan",
                                            useTitle: true,
                                            maintainsContext: false,
                                        },
                                    },
                                    {
                                        path: "price-lists",
                                        component: () => import("@/layouts/Wrapper.vue"),
                                        meta: { title: "Price lists", maintainsContext: false },
                                        children: [
                                            {
                                                path: "",
                                                name: "GroupLocationGroupPricingEnergy",
                                                component: () =>
                                                    import("@/views/pricing/EnergyPricing.vue"),
                                                meta: {
                                                    title: "Price lists",
                                                    maintainsContext: false,
                                                },
                                            },
                                            {
                                                path: "create",
                                                name: "GroupLocationGroupCreatePriceList",
                                                component: () =>
                                                    import("@/views/pricing/PriceListView.vue"),
                                                meta: {
                                                    title: "Create pricing plan",
                                                    maintainsContext: false,
                                                },
                                            },
                                            {
                                                path: ":priceListId",
                                                name: "GroupLocationGroupEditPriceList",
                                                component: () =>
                                                    import("@/views/pricing/PriceListView.vue"),
                                                meta: {
                                                    title: "Edit pricing plan",
                                                    useTitle: true,
                                                    maintainsContext: false,
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        path: "plans",
                                        component: () => import("@/layouts/Wrapper.vue"),
                                        meta: {
                                            title: "Time of Use Plan",
                                            maintainsContext: false,
                                        },
                                        children: [
                                            {
                                                path: "",
                                                name: "GroupLocationGroupPricingPlans",
                                                component: () =>
                                                    import(
                                                        "@/views/pricing/UtilityAndNetworkPlans.vue"
                                                    ),
                                                meta: {
                                                    title: "Time of Use Plan",
                                                    maintainsContext: false,
                                                },
                                            },
                                            {
                                                path: "create",
                                                name: "GroupLocationGroupCreatePricingPlan",
                                                component: () =>
                                                    import("@/views/pricing/PricingPlanView.vue"),
                                                meta: {
                                                    title: "Create utility plan",
                                                    maintainsContext: false,
                                                },
                                            },
                                            {
                                                path: ":planId",
                                                name: "GroupLocationGroupEditPricingPlan",
                                                component: () =>
                                                    import("@/views/pricing/PricingPlanView.vue"),
                                                meta: {
                                                    title: "Edit utility plan",
                                                    useTitle: true,
                                                    maintainsContext: false,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "spot-market",
                                name: "GroupLocationGroupSpotMarket",
                                component: () => import("@/views/pricing/SpotMarketView.vue"),
                                meta: {
                                    title: "Energy Market Prices",
                                    type: "location-spot-market",
                                    maintainsContext: false,
                                },
                            },
                        ],
                    },
                    {
                        path: "charts",
                        name: "GroupLocationCharts",
                        component: () => import("@/views/location/LocationChart.vue"),
                        meta: { title: "Charts", type: "location-charts", maintainsContext: false },
                    },
                    {
                        path: "category/:categoryId",
                        name: "GroupLocationCategory",
                        component: () => import("@/views/location/LocationCategory.vue"),
                        meta: { title: "Category info", useTitle: true, maintainsContext: false },
                    },
                    {
                        path: "strategies",
                        name: "GroupLocationStrategies",
                        component: () => import("@/views/location/LocationStrategies.vue"),
                        meta: {
                            title: "Strategies",
                            type: "location-strategies",
                            maintainsContext: false,
                        },
                    },
                    {
                        path: "strategies/:strategyId",
                        name: "GroupLocationStrategy",
                        component: () => import("@/views/settings/oem-device/Strategy.vue"),
                        meta: { title: "Strategy", useTitle: true, maintainsContext: false },
                    },
                    {
                        path: "ev-charging",
                        name: "GroupLocationEvChargingSessions",
                        component: () =>
                            import("@/views/location/ev-charging/EvChargingSessions.vue"),
                        meta: { title: "EV Charging Sessions", type: "ev-charging", maintainsContext: false },
                    },
                    {
                        path: "alarm-settings",
                        name: "GroupLocationAlarmSettings",
                        component: () => import("@/views/location/LocationAlarmSettings.vue"),
                        meta: {
                            title: "Alarm settings",
                            type: "location-alarm-settings",
                            maintainsContext: false,
                        },
                    },
                    {
                        path: "summary",
                        name: "GroupLocationSummary",
                        component: () => import("@/views/location/LocationSummary.vue"),
                        meta: { title: "Location summary", maintainsContext: false },
                    },
                    {
                        path: "flexibility",
                        name: "GroupLocationFlexibility",
                        component: () =>
                            import("@/views/location-groups/LocationGroupHeaderView.vue"),
                        meta: { title: "Flexibility", maintainsContext: false },
                    },
                    {
                        path: "device-groups/:deviceGroupId",
                        component: () => import("@/views/location/group/Group.vue"),
                        meta: { maintainsContext: false },
                        children: [
                            {
                                path: "",
                                name: "GroupDeviceGroup",
                                component: () => import("@/views/location/group/GroupOverview.vue"),
                                meta: { title: "Group overview", maintainsContext: false },
                            },
                            {
                                path: "devices/:did",
                                name: "GroupDevice",
                                component: () => import("@/views/location/device/Device.vue"),
                                meta: { title: "Device", type: "device", maintainsContext: false },
                            },
                        ],
                    },
                ],
            },
        ],
    },
]
